import React, { useState, useRef } from "react";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import { useTranslation } from "react-i18next";

const PhoneOrEmail = ({
  onDatasubmit,
  loading,
  showNotification,
  changeerror,
}) => {
  const { t } = useTranslation();
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Module-independent lock that persists across renders and is checked
  // BEFORE anything else runs — this is the actual gate.
  const lockRef = useRef(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10 && Number(value) < 9999999999) {
      setMobile(value);
    }
    changeerror();
  };

  const validateMobile = () => {
    if (!mobile) return t("mobile_required") || "Mobile number is required";
    if (mobile.length !== 10)
      return t("mobile_invalid") || "Enter a valid 10-digit mobile number";
    return "";
  };

  const handleSend = async () => {
    // Gate #1: synchronous ref check, nothing above this line

    const validationError = validateMobile();
    if (validationError) {
      setError(validationError);

      return;
    }

    setError("");
    setIsSubmitting(true);

    try {
      await onDatasubmit("Send Otp", { mobile });
    } finally {
      setIsSubmitting(false);
    }
  };

  const busy = isSubmitting || loading;

  return (
    <div className="w-full md:w-[75%] mx-auto">
      <h1 className="text-lg font-bold text-black text-center mb-1">
        {t("forgot_password_heading1")}
      </h1>
      <p className="text-center text-sm font-normal text-[#5C5C5C] mb-6">
        {t("forgot_password_note")
          .split("<br/>")
          .map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </p>

      <div className="mb-6">
        <InputBox
          type="number"
          maxlength={11}
          label={t("Mobile Number")}
          name="mobile"
          placeholder={t("Enter mobile number")}
          onChange={handleInputChange}
          value={mobile}
          error={error || showNotification}
          touched={true}
        />
        {showNotification ? (
          <div className="text-sm mt-2 text-red justify-center">
            {t("provide_registered_number")}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        onClick={()=>{
    lockRef.current = true;   // locked immediately, same tick as the click
          handleSend()}}
        disabled={lockRef.current}
        aria-disabled={busy}
        style={busy ? { pointerEvents: "none" } : undefined}
        className={`w-full px-4 py-2 mt-4 text-white rounded-lg ${
          busy ? "bg-gray-400 cursor-not-allowed" : "bg-primaryBlue"
        }`}
      >
        {busy ? t("sending") || "Sending..." : t("send")}
      </button>
    </div>
  );
};

export default PhoneOrEmail;